import PairsMinigame from "./components/PairsMinigame";

const index = ({ className = "" }: { className?: string }) => {
  return (
    <div className={`${className}`}>
      <PairsMinigame />
    </div>
  );
};

export default index;
